module.exports = __webpack_public_path__ + "img/webp.6fd5b246.webp";